import { AbstractControl, ValidationErrors } from '@angular/forms';

export function integerValidator(control: AbstractControl): ValidationErrors | null {
  const v = control.value;
  if (v === '' || v === null || v === undefined) {
    return null;
  }
  const n = typeof v === 'number' ? v : parseFloat(String(v));
  if (Number.isNaN(n)) {
    return { integer: true };
  }
  return Number.isInteger(n) ? null : { integer: true };
}
